import isEmpty from "lodash/isEmpty";

export default {
  methods: {
    valueHandedAndFilled(value) {
      return value != undefined && isEmpty(value) === false;
    }
  }
}
